import React from 'react';

const BrandLogo = ({ className = '' }) => {
  return (
    <img
      src="/images/singh-logo.png"
      alt="Singh Logistics WA - Refrigerated Transport"
      className={`h-20 md:h-24 w-auto object-contain ${className}`}
    />
  );
};

export default BrandLogo;
